import { all, call, fork, put, takeLeading } from 'redux-saga/effects'
import * as types from 'store/types'
import * as apis from 'store/apis'
import * as actions from 'store/actions'
import { handleApiError } from 'utils/helpers'

function* getAdminPageTemplates_saga() {
  try {
    const result = yield call(apis.getAdminPageTemplates_api)
    yield put(actions.setAdminPageTemplates_action(result))
  } catch (error) {
    // handleApiError(error)
  }
}
function* getTeamPageTemplates_saga() {
  try {
    const result = yield call(apis.getTeamPageTemplates_api)
    yield put(actions.setTeamPageTemplates_action(result))
    // const { is_admin_template_loaded, is_team_template_loaded } = yield select((state) => state.templates)
    // yield put(actions.)
  } catch (error) {
    // handleApiError(error)
  }
}
function* savePageTemplate_saga({ data, resolve, reject }) {
  try {
    if (data.uuid) {
      const result = yield call(apis.updatePageTemplates_api, data)
      yield put(actions.setEditedTemplate_action(result))
    } else {
      const result = yield call(apis.createPageTemplates_api, data)
      yield put(actions.setNewTemplate_action(result))
    }
    resolve && resolve()
  } catch (error) {
    handleApiError(error)
    reject && reject()
  }
}

export function* watchSagas() {
  // DRAFTS
  yield takeLeading(types.GET_ADMIN_PAGE_TEMPLATES, getAdminPageTemplates_saga)
  yield takeLeading(types.GET_TEAM_PAGE_TEMPLATES, getTeamPageTemplates_saga)
  yield takeLeading(types.SAVE_TEMPLATE, savePageTemplate_saga)
}
export default function* templateSagas() {
  yield all([fork(watchSagas)])
}
